import { render, staticRenderFns } from "./OrderQrCode.vue?vue&type=template&id=a636b7e8&"
import script from "./OrderQrCode.vue?vue&type=script&lang=js&"
export * from "./OrderQrCode.vue?vue&type=script&lang=js&"
import style0 from "./OrderQrCode.vue?vue&type=style&index=0&id=a636b7e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports